<div class="d-flex flex-column align-items-center">
	<div class="chart-sum text-primary">{{ getSum() }}</div>
	<div class="text-center">{{ label }}</div>
</div>
